export default __webpack_public_path__ + "static/media/welzheim_light.5affed02.png";